import { useState, useEffect } from 'react';

const THEME_KEY = 'ced_admin_theme';

/**
 * Hook para gestionar el estado del tema moderno (NEW) vs clásico (CLASSIC)
 * Persiste en localStorage y sincroniza la clase 'theme-new' en body
 */
function useTheme() {
  const [isNewTheme, setIsNewTheme] = useState(
    () => localStorage.getItem(THEME_KEY) === 'new'
  );

  const toggle = () => {
    setIsNewTheme((prev) => {
      const next = !prev;
      localStorage.setItem(THEME_KEY, next ? 'new' : 'classic');
      document.body.classList.toggle('theme-new', next);
      return next;
    });
  };

  useEffect(() => {
    document.body.classList.toggle('theme-new', isNewTheme);
  }, [isNewTheme]);

  return { isNewTheme, toggle, THEME_KEY };
}

export default useTheme;
